import React, { ReactElement, useEffect, useState } from "react";
import { Avatar, Box, Chip, Stack, Typography, useTheme } from '@mui/material';
import { ReactComponent as CaregiverSVG } from '../assets/caregiver.svg';
import { ReactComponent as MMWarriorSVG } from '../assets/patienticon.svg';
import { ReactComponent as BladderCancerSVG } from '../assets/patienticonbladder-cancer.svg'
import { ReactComponent as HeartFailureSVG } from '../assets/patienticonheart-failure.svg'
import { ReactComponent as JuvenileMyositisSVG } from '../assets/patienticonjuvenile-myositis.svg'
import { ReactComponent as AdultMyositisSVG } from '../assets/patienticonadult-myositis.svg'
import { ReactComponent as MedicSVG } from '../assets/medic.svg';
import { ReactComponent as OtherSVG } from '../assets/other.svg';
import { ReactComponent as CareCenterSVG } from '../assets/carecentericon.svg';
import { ReactComponent as HousingSVG } from '../assets/house.svg';
import { ReactComponent as CoeSVG } from '../assets/coe.svg';
import { ReactComponent as SupportGroupSVG } from '../assets/support_group.svg';
import { ReactComponent as ClinicalTrialSVG } from '../assets/clinical_trial.svg'
import { ReactComponent as WalkSVG } from '../assets/walk.svg'
//import { Condition, baseName, coonditionContext } from "../..";
// import CaregiverSVG2 from '../assets/caregiver.svg';
// import MMWarriorSVG2 from '../assets/patienticon.svg';
// import MedicSVG2 from '../assets/medic.svg';


import PlaceIcon from '@mui/icons-material/Place';
import { GetPinName } from './map/MapFilter';
import Button from '@mui/material/Button';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
//import { setClickedMessageIAM } from "../features/dataProcessingSlice";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { themePolygon } from '../app/theme';
import { useAuthProfile } from "../app/hooks"
import { chatApi, DirectChatUsers, useSetChatUserMutation } from '../features/ChatSlice';
import { CircularProgressCentered } from "../app/components/sharedcomponents";

import LoadingButton from '@mui/material/Button';
//import { IsProdChatUserInTest, prodChatUserInTestMessage } from "./messaging/ChatMain";
import { GetUserTypePinPNG, StartChat } from "./markers/MMMarkers";

import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import { useUpdateUsernameMutation } from '../features/profilesSlice';
import { GetIntitutionTypePinPNG, MarkerTypeOption } from "./markers/InstitutionMarkers";
import { baseName } from "..";

export const pinIconStyle = { width: '26px', height: '26px' }


export const GetUserTypePin = (name: string, props: any = {}) => GetPinByCategoryAndType("User", name, props)

export type PinCategory = "Institution" | "User";
interface PatientPNGComponentProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  // You can add custom props if needed, but this will allow all img props
  pincategory: PinCategory
  id: string
}
export const PinPNGComponent: React.FC<PatientPNGComponentProps> = (props) => {

  let pinPNG = props.pincategory === 'User' ? GetUserTypePinPNG(props.id) : //'P')
    GetIntitutionTypePinPNG(props.id)
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <img src={pinPNG as string} {...props} />
    </Box>
  );
};


const GetPatientSVG = (props: any) => {
  //return <MedicSVG {...props} />
  switch (baseName) {
    case 'bladder-cancer':
      return <BladderCancerSVG {...props} />
    case 'heart-failure':
      return <HeartFailureSVG {...props} />
    case 'juvenile-myositis':
      return <JuvenileMyositisSVG {...props} />
    case 'adult-myositis':
      return <AdultMyositisSVG {...props} />
    case 'multiple-myeloma':
      return <MMWarriorSVG {...props} />
    default:
      return <MMWarriorSVG {...props} />

  }
}
export const GetPinByCategoryAndType = (category: PinCategory, markerTypeVsMarkerTypeOption: string | MarkerTypeOption, props: any = {}, isSvg: boolean = true) => {
  const { type: markerType, status: option } = typeof markerTypeVsMarkerTypeOption === 'object' ? markerTypeVsMarkerTypeOption : { type: markerTypeVsMarkerTypeOption, status: undefined }
  switch (category) {
    case "Institution":
      switch (markerType) {
        case "E":
          return { icon: <CoeSVG {...props} />, color: '#FFEDED', namePlural: "Treatment Center(s)" }
        case "C":
          return { icon: <CareCenterSVG {...props} />, color: '#FFF5D1', namePlural: "Care Center(s)" }
        case "H":
          return { icon: <HousingSVG {...props} />, color: '#E0EEED', namePlural: "Patient Lodging" }
        case "S":
          return { icon: <SupportGroupSVG {...props} />, color: '#E0EEED', namePlural: "Support Group(s)" }
        case "TR1,2,3":
          return { icon: <ClinicalTrialSVG {...props} />, color: 'yellow', namePlural: "Clinical Trial(s) Phase I/II" }
        case "TR4,5":
          return { icon: <ClinicalTrialSVG {...props} />, color: 'yellow', namePlural: "Clinical Trial(s) Phase III/IV" }
        case "WALK":
          return { icon: <WalkSVG {...props} />, color: 'yellow', namePlural: "BCAN Walk(s)" }
        case "BSTP":
          return { icon: <PinPNGComponent {...props} pincategory="Institution" id="BSTP" />, color: 'rgb(206,250,255)', namePlural: "Wheeling for Healing" }
        default:
          return { icon: <OtherSVG {...props} />, color: '#FFEDED' }
      }
      break;

    case "User":
      switch (markerType) {
        case "P":
          //return { icon: <MMWarriorSVG {...props} />, color: '#FFEDED', namePlural: "Patient(s)" }

          return { icon: isSvg ? GetPatientSVG(props) : <PinPNGComponent {...props} pincategory="User" id={markerType} />, color: '#FFEDED', namePlural: "Patient(s)" }
        case "C":
          return { icon: isSvg ? <CaregiverSVG {...props} /> : <PinPNGComponent {...props} pincategory="User" id={markerType} />, color: '#FFF5D1', namePlural: "Caregiver(s)" }
        case "M":
          return { icon: isSvg ? <MedicSVG {...props} /> : <PinPNGComponent {...props} pincategory="User" id={markerType} />, color: '#E0EEED', namePlural: "Health Care Professional(s)" }
        case "O":
          return { icon: isSvg ? <OtherSVG {...props} /> : <PinPNGComponent {...props} pincategory="User" id={markerType} />, color: '#E7E7E7', namePlural: "Other" }
        default:
          return { icon: isSvg ? <OtherSVG {...props} /> : <PinPNGComponent {...props} pincategory="User" id={markerType} />, color: '#E7E7E7' }
      }
  }
}


export const PinChip: React.FC<{ category: PinCategory, type: string, size: any, iconSizePx?: number, sx?: any }> = ({ category, type, size, iconSizePx = 28, sx: sxProp }) => {
  const pinIconStyle = { width: `${iconSizePx}px`, height: `${iconSizePx}px` };
  const pinData = GetPinByCategoryAndType(category, type, { style: pinIconStyle }, false)
  return (
    <Chip
      label={pinData.namePlural?.replace("(s)", "")}
      size={size}
      icon={pinData.icon}
      sx={{ pt: 2, pb: 2, width: 'fit-content', backgroundColor: pinData.color, border: '1px solid rgba(0,0,0,0.08)', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', ...sxProp }}
    />
  )
}

//export StartDirectChat( { messageTo: profile.iam_id, id: profile.id })

export const MessageProfile: React.FC<{ profile: any, showMessageButton?: boolean, onEdit?: () => void, renderUserName?: () => ReactElement, hideUserAndLocationPinsForIncompleteProfile?: boolean }> = ({ renderUserName, onEdit, profile, showMessageButton = true, hideUserAndLocationPinsForIncompleteProfile }) => {
  const dispatch = useDispatch<any>();
  const profile_iam = useSelector((state: any) => state.dataProcessing.publicPinProfile)
  const navigate = useNavigate()
  const { authStatus, profile: profileLoggedIn, isLoading: isLoadingpProfileLoggedIn, isSuccess, isError, error } = useAuthProfile()
  const [SetChat, { isLoading: isLoadingSetChat, isSuccess: isSuccessSetChat, isError: isErrorSetChat, error: errorSetChat, data: setChatData, reset }] = useSetChatUserMutation()
  //const [editUsername, setEditUsername] = useState(false)
  //const [errorUsername, setErrorUsername] = useState('')
  //const [usernameText, setUsernameText] = useState('')
  //const [SetUsername, { isLoading: isLoadingSetUsername, isSuccess: isSuccessSetUsername, error: errorSetUsername, data: setUsernameData }] = useUpdateUsernameMutation()



  // async function handleEditUsername() {
  //   if (usernameText.length == 0) {
  //     setEditUsername(false)
  //     return
  //   }

  //   if (usernameText.length >= 80) {
  //     setErrorUsername('Please enter a username smaller than 80 characters')
  //     return
  //   }

  //   setErrorUsername('')
  //   const result = await SetUsername({ id: profileLoggedIn.id, username: usernameText })
  //   if (result.data.message == 'Username updated successfully') {
  //     setEditUsername(false)
  //     //window.location.reload()
  //     refetchProfile();
  //   } else if (result.data.message == 'Username is already taken') {
  //     setErrorUsername(result.data.message)
  //   } else {
  //     setErrorUsername('Something went wrong')
  //   }
  // }

  //   (profile.id == profileLoggedIn.id && onEdit) && <IconButton aria-label="delete" onClick={()=>{setEditUsername(true)}}>
  //   <EditIcon />
  // </IconButton>
  // }

  // useEffect(() => {
  //   if (isSuccessSetChat) {
  //     //console.log("setChatData", setChatData)
  //     // if( !messagingReady)
  //     //   dispatch(chatApi.util.invalidateTags(['Ready']))
  //     navigate("/Messages", { state: { chatAndUserData: setChatData } })//navigate("/Messages", { state: { messageTo: profile.iam_id, id: profile.id } })
  //   }
  // }, [isSuccessSetChat])

  if (isError) {
    const errMsg = (error &&'status' in error) ? `Error: ${error.status}` : 'error';
    return <div>{errMsg}</div>;
  }
  const showUserAndLocationPins = (hideUserAndLocationPinsForIncompleteProfile && profileLoggedIn.is_completed) || !hideUserAndLocationPinsForIncompleteProfile
  const userName = renderUserName ? renderUserName() : profile.name_public
  return (
    <Box sx={{ border: '1px solid', borderRadius: 3, borderColor: '#E0DEFF', p: 2.5, mb: 2, mt: 2 }}>
      <Stack direction="column" gap={1.5}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Avatar sx={{ width: 40, height: 40, bgcolor: '#656EFF', fontSize: 16, fontWeight: 600, flexShrink: 0 }}>
            {profile.name_public?.[0]?.toUpperCase() ?? '?'}
          </Avatar>
          <Stack direction="column" gap={0.25} sx={{ flex: 1, minWidth: 0 }}>
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1a1a2e', lineHeight: 1.2 }}>
                {userName}
              </Typography>
              {(profile.id == profileLoggedIn?.id && onEdit) && (
                <IconButton aria-label="edit" size="small" onClick={() => onEdit()} sx={{ ml: 'auto' }}>
                  <EditIcon sx={{ fontSize: 16, color: '#9E9E9E' }} />
                </IconButton>
              )}
            </Stack>
            {showUserAndLocationPins && <PinChip category="User" type={profile.type} size="small" />}
          </Stack>
        </Stack>
        {showUserAndLocationPins && profile.formattedsearchterm && (
          <Stack direction="row" alignItems="center" gap={0.5} sx={{ ml: '52px' }}>
            <PlaceIcon sx={{ color: '#656EFF', fontSize: 16, flexShrink: 0 }} />
            <Typography variant="caption" sx={{ color: '#656EFF' }}>
              {profile.formattedsearchterm}
            </Typography>
          </Stack>
        )}
        {(showMessageButton && profileLoggedIn?.id != profile.id) && (
          <LoadingButton
            id="profile_message_button"
            loadingPosition="start"
            loading={isLoadingSetChat}
            onClick={async () => {
              navigate({
                pathname: "/Conversations", search: new URLSearchParams({ directId: profile.id, directNamePublic: profile.name_public, }).toString(),
              });
            }}
            variant="contained"
            disableElevation
            startIcon={<SmsOutlinedIcon />}
            sx={{ mt: 0.5, borderRadius: 2, textTransform: 'none', fontWeight: 600, background: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)', color: 'white', boxShadow: '0 2px 8px rgba(139,92,246,0.25)', '&:hover': { background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)' } }}
          >
            Message
          </LoadingButton>
        )}
        {(isLoadingSetChat || isLoadingpProfileLoggedIn) && <CircularProgressCentered />}
      </Stack>
    </Box>
  )
}

